import React, { useEffect } from 'react';

const PartnerDiscountRedirectZendesk = () => {
  useEffect(() => {
    if (window?.location) {
      const baseUrl = 'https://gemfinance.zendesk.com/hc/en-nz/requests/new?ticket_form_id=39192515813521';
      const queryParams = window.location.search;
      const redirectUrl = queryParams ? `${baseUrl}${queryParams}` : baseUrl;

      window.location.replace(redirectUrl);
    }
  }, []);

  return null;
};

export default PartnerDiscountRedirectZendesk;